(() => {
    let carousels = document.querySelectorAll(
        '.js-link-collection-carousel.-logo-carousel'
    );

    if (!carousels.length) {
        return;
    }

    carousels.forEach(function (splideElement) {
        const isRightDirection =
            splideElement.classList.contains('-direction-right');

        const args = {
            type: 'loop',
            arrows: true,
            perMove: 0,
            autoScroll: { speed: isRightDirection ? -1 : 1 },
            intersection: {
                inView: {
                    autoScroll: true,
                },
                outView: {
                    autoScroll: false,
                },
            },
            pagination: false,
            arrowPath: ' ',
            mediaQuery: 'min',
            breakpoints: {
                0: {
                    fixedWidth: '150px',
                    fixedHeight: '113px',
                    gap: '4px',
                },
                560: {
                    fixedWidth: '349px',
                    fixedHeight: '249px',
                    gap: '8px',
                },
            },

            i18n: H_Tools.carousel?.getLabels(splideElement),
        };

        let splide = new Splide(splideElement, args);

        // Store a reference to the Splide object
        H_Tools.carousel[splideElement.getAttribute('data-carousel-id')] =
            splide;

        H_Tools.carousel?.addListeners(splide, splideElement);

        splide.mount(window.splide.Extensions);
    });
})();
